import { render, staticRenderFns } from "./NewTransportationDocumentPage.vue?vue&type=template&id=96803e64&scoped=true"
import script from "./NewTransportationDocumentPage.vue?vue&type=script&lang=js"
export * from "./NewTransportationDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96803e64",
  null
  
)

export default component.exports